import type { RiskFlag as RiskFlagType } from '../../activeLoanModel';

/** Left-edge stripe marking a flagged loan, on a table row or a loan card. */
export const FLAG_STRIPE_CLASS: Record<RiskFlagType, string> = {
  stalled: 'shadow-[inset_3px_0_0_0_hsl(38_92%_50%)]'
};

/**
 * Pills keep their text on one line by default. In the narrower layouts they
 * may wrap instead of spilling out of their column.
 */
export const WRAPPING_PILL_CLASS = 'max-w-full whitespace-normal';
